export const FETCHING_SINGLE_DISC_START = 'fetching_single_discussion_start';
export const FETCHING_SINGLE_DISC_END = 'fetching_single_discussion_end';
export const FETCHING_SINGLE_DISC_SUCCESS = 'fetching_single_discussion_success';
export const FETCHING_SINGLE_DISC_FAILURE = 'fetching_single_discussion_failure';

export const TOGGLE_FAVORITE_START = 'toggle_favorite_start';
export const TOGGLE_FAVORITE_SUCCESS = 'toggle_favorite_success';
export const TOGGLE_FAVORITE_FAILURE = 'toggle_favorite_failure';

export const UPDATE_OPINION_CONTENT = 'update_opinion_content';

export const POSTING_OPINION_START = 'posting_opinion_start';
export const POSTING_OPINION_SUCCESS = 'posting_opinion_success';
export const POSTING_OPINION_FAILURE = 'posting_opinion_failure';

export const DELETE_DISC_START = 'delete_disc_start';
export const DELETE_DISC_SUCCESS = 'delete_disc_success';
export const DELETE_DISC_FAILURE = 'delete_disc_failure';
export const DELETE_DISC_REDIRECT = 'delete_disc_redirect';

export const DELETE_OPINION_START = 'delete_opinion_start';
export const DELETE_OPINION_SUCCESS = 'delete_opinion_success';
export const DELETE_OPINION_FAILURE = 'delete_opinion_failure';
